define(
    'actions/viewbuncee',[
        "backbone",
        "dispatcher/AppDispatcher",
        "constants/actiontypes",
        "shared/crm"
    ],
    function(Backbone, AppDispatcher, Constants, CRM)
    {
        return Backbone.Model.extend({
            init: function(params) {
            },
            pullComments : function(guid) {
                var comments = [];
                var self = this;

                $.ajax({
                    url : window.appData.client.api_url+"/buncees/"+guid+"/comments",
                    success: function(response) {
                        _.each(response.data, function(comment) {
                            self.addComment(comment);
                        })

                    }
                })
            },
            pullLikes : function(guid) {
                window.api.request("buncees",guid,"likes").execute().done(function(response) {
                    AppDispatcher.dispatch({
                        actionType: Constants.SET_LIKE_COUNT,
                        data: response.data
                    });
                });
            },
            pullLikeState : function(guid) {
                window.api.request("buncees",guid,"like").execute().done(function(response) {
                    if(response.data) {
                        AppDispatcher.dispatch({
                            actionType: Constants.TOGGLE_LIKE_STATE,
                            data: {
                                increment : false
                            }
                        });
                    }
                });
            },
            getUserAgent: function() {
                return {
                    userAgent: window.navigator.userAgent,
                    isMobileSafari: function() {
                        return this.isIPhone() && this.isSafari();
                    },
                    /**
                     * Determine whether the browser is Safari
                     * @author Haley He
                     * @dateCreated 10/18/19
                     * @return {boolean} true if the user is on the Safari browser, false otherwise
                     */
                    isSafari: function() {
                        return /^((?!CriOS|chrome|android).)*safari/i.test(navigator.userAgent);
                    },
                    isMobile: function() {
                        if(this.userAgent.indexOf("Mobile") >= 0 || this.userAgent.indexOf("Android") >= 0)
                            return true;
                        return false;
                    },
                    isBuggyIframe: function() {
                        if((this.userAgent.indexOf("Mobile") >= 0 && this.userAgent.indexOf("Safari") >= 0) || this.userAgent.indexOf("iPhone") >= 0 || this.userAgent.indexOf("iPad") >= 0)
                            return true;
                        return false;
                    },
                    isMobileStrict : function() {
                        if(this.userAgent.indexOf("Mobile") >= 0 || this.userAgent.indexOf("Android") >= 0) {
                            if(this.userAgent.indexOf("iPad") >= 0) {
                                return false;
                            }
                            return true;
                        }
                        return false;
                    },
                    /**
                     * Determine whether the device is an iPhone
                     * @author Haley He
                     * @dateCreated 10/10/19
                     * @return {boolean} true if the device is an iPhone, false otherwise
                     */
                     isIPhone: function() {
                        return /iPhone/i.test(this.userAgent);
                    },
                    /**
                     * Determine whether the device is an iPad / iPad Pro
                     * @author Haley He
                     * @dateCreated 10/10/19
                     * @return {boolean} true if the device is an iPad / iPad Pro, false otherwise
                     */
                    isIPad: function() {
                        return /iPad/i.test(this.userAgent) || (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
                    },
                    /**
                     * Get the Safari version number
                     * @author Haley He
                     * @dateCreated 10/18/19
                     * @return {number} the Safari version number
                     */
                    getSafariVersion: function() {
                        var version = navigator.userAgent.substring(navigator.userAgent.indexOf("Version"));
                        // Parse the version number
                        var versionNumber = parseInt(version.substring(version.indexOf("/")+1,version.indexOf(".")));
                        return versionNumber;
                    }
                };
            },
            setCommentable: function (guid, value) {
                window.api.request("buncees", guid).update({
                    "data": JSON.stringify({"commentable": new Boolean(value)}),
                    "last_modified": Math.round(Date.now() / 1000)
                });
                AppDispatcher.dispatch({
                    actionType: Constants.SET_COMMENTABLE,
                    data: value
                });
            },
            setCopyable: function(guid, value) {
                window.api.request("buncees", guid).update({
                    "data": JSON.stringify({"copyable": new Boolean(value)}),
                    "last_modified": Math.round(Date.now() / 1000)
                });
                AppDispatcher.dispatch({
                    actionType: Constants.SET_COPYABLE,
                    data: value
                });
            },
            setPrivacy: function(guid, value) {
                window.api.request("buncees", guid).update({
                    "data": JSON.stringify({"privacy_level": value}),
                    "last_modified": Math.round(Date.now() / 1000)
                });
                AppDispatcher.dispatch({
                    actionType: Constants.SET_PRIVACY,
                    data : value
                });
            },
            updateBuncee : function(params) {
                window.api.request("buncees", params.guid).update({'data' : JSON.stringify(params)});
            },
            toast : function(contextNode,message,displayTime, top) {
                var toastBox = document.createElement("div");
                var context = $(contextNode);
                displayTime = displayTime || 2000;

                toastBox.id = "toast";
                context.append(toastBox);


                toastBox = $("#toast");
                toastBox.html(message).css({
                    "top": top || context.position().top + context.height() - 50
                });

                toastBox.animate({
                    "opacity" : 1
                },500).delay(displayTime).animate({
                    "opacity": 0
                },500,function(){
                    toastBox.css("display","none").remove();
                });
            },
            requestPDF: function(guid, onPdfComplete){
                if(this.pdf_job_id){
                    delete this.pdf_job_id;
                }

                var self = this;
                var api = require("api");

                window.api.request("buncees", guid, "pdf").create({}).done(function(response) {
                    self.pdf_job_id = response.job_key;

                    (function pingJobStatus(jobId, attempt) {
                        window.api.request("jobs", jobId).execute().done(function (response, textStatus, jqXHR) {
                            var statusCode = jqXHR.statusCode().status;
                            if (statusCode >= 400) {
                                // An error occured....
                            } else if (statusCode > 200 && statusCode < 400) {
                                // If we're still waiting on the same job, ping it again.
                                if (self.pdf_job_id == jobId && attempt <= 60) {
                                    setTimeout(function () {
                                        pingJobStatus(jobId, attempt + 1);
                                    }, 2000);
                                }
                            } else if (statusCode == 200) {
                                if(response.data.hasOwnProperty("output")) {
                                    var output = response.data.output;
                                    if (output.url) {
                                        self.pdf_url = output.url;
                                    }
                                }
                                onPdfComplete();
                            }
                        }).fail(function (jqXHR, textStatus, errorThrown) {
                            //>>includeStart("debug", pragmas.debug);
                            console.error(jqXHQ, textStatus, errorThrown);
                            //>>includeEnd("debug");
                            if (attempt <= 5) {
                                setTimeout(function () {
                                    pingJobStatus(jobId, attempt + 1);
                                }, 2000);
                            } else {
                                // Give up...something is up with the thumbnail generation server.
                                delete self.pdf_job_id;
                            }
                        });
                    })(this.response.job_key, 0);
                });
            },
            postComment : function(guid, comment) {
                var self = this;
                window.api.request("buncees",guid, "comments").create({body:comment}).done(function(response) {
                    self.addComment({
                        guid : response.data,
                        owner_guid : window.appData.user.data.guid,
                        first_name : window.appData.user.data.first_name,
                        last_name : window.appData.user.data.last_name,
                        avatar : window.appData.user.data.avatar,
                        body : comment
                    });
                    CRM.event("buncee:comment:create", {guid: response.data});
                });
            },
            addComment : function(params){
                AppDispatcher.dispatch({
                    actionType: Constants.ADD_COMMENT,
                    data: params
                });
            },
            deleteComment : function(guid, commentGuid) {
                window.api.request("buncees",guid, "comments",commentGuid).delete().done(function(response) {
                    AppDispatcher.dispatch({
                        actionType: Constants.REMOVE_COMMENT,
                        data: {
                            guid : commentGuid
                        }
                    });
                    CRM.event("buncee:comment:delete", {guid:guid, commentGuid: commentGuid});
                });
            },
            createTags : function(guid, tags) {
                var self = this;
                console.log(tags);
                window.api.request("buncees",guid, "tags").create({data:JSON.stringify(tags)}).done(function(response) {
                    _.each(response.data, function(tag) {
                        self.addTag({
                            guid : tag.guid,
                            tag : tag.tag
                        })
                    });
                });
            },
            addTag : function(params) {
                AppDispatcher.dispatch({
                    actionType: Constants.ADD_TAG,
                    data: params
                });
            },
            removeTag : function(guid, tagGuid) {
                window.api.request("buncees",guid, "tags",tagGuid).delete().done(function(response) {
                    AppDispatcher.dispatch({
                        actionType: Constants.REMOVE_TAG,
                        data: {
                            guid : tagGuid
                        }
                    });
                });
            },
            getTagSuggestions : _.debounce(function(target, onComplete) {
                var query = target.value
                window.appData.local.suggestedTags = [];
                var self = this;
                if(window.appData.local.tagsQuery){
                    clearTimeout(window.appData.local.tagsQuery);
                }
                query = {
                    keywords : query
                };
                var search = window.api.custom(window.appData.client.api_url + "/tags", query).execute().done(function(response) {
                    if(target.value != "") {
                        if(response) {
                            window.appData.local.suggestedTags = response.data;    
                        } 
                    } else {
                        window.appData.local.suggestedTags = null;
                    }
                    onComplete();
                });
                // window.appData.local.tagsQuery = setTimeout(search, 500);
            }, 500),
            toggleLikeState : function(guid){
                window.api.request("buncees",guid,"like").create({}).done(function(response) {
                    AppDispatcher.dispatch({
                        actionType: Constants.TOGGLE_LIKE_STATE,
                        data: {
                            increment : true
                        }
                    });
                    CRM.event("buncee:like", {guid:guid});
                });
            },
            postClips: function(slides, onComplete, onFailed) {
                var self = this;
                var data = {
                    buncee_id: appData.buncee.data.guid,
                    slides: slides
                };
                window.api.request("clips").create(data).done(function(response) {
                    if(typeof onComplete == "function") {
                        onComplete();
                    }
                });
            }
        });
    }
);
